import { TOAST_ICON_DISABLED, TOAST_ICON_TOGGLE } from "../type";

export const toastIconToggleAction = (data) => ({ type: TOAST_ICON_TOGGLE, payload: data })
export const toastIconDisabledAction = () => ({ type: TOAST_ICON_DISABLED })